import InfoCsvExportButton from "../../components/InfoCsvExportButton.js";
import { detailedPopulationCsv } from "../../utils/info-report-csv.js";
import { memo, useState } from "react";
import Spinner from "../../components/Spinner.js";
import SelectOwnerForm from "../../components/forms/OwnerSelect.js";
import { useSnackbar } from "../../utils/index.js";
import { getOwnerPopulationDetailed, getLastUpdateDate, createInventory, getInventories, deleteInventory } from "../../api/index.js";
import OwnerPopulationSummary from "../../components/OwnerPopularitySummary.js";
import OwnerPopulationDetailsPdf from "../../components/info-pdfs/OwnerPopulationDetails.js";
import OwnerPopulationDetailsSummaryPdf from "../../components/info-pdfs/OwnerPopulationDetailsSummary.js";
import OwnerPopulationTable from "../../components/OwnerPopulationDetailsTable.js";

const OwnerPopulationDetailed = () => {
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedData, setFetchedData] = useState([]);
    const [step, setStep] = useState(1);
    const [selectedData, setSelectedData] = useState([]);
    const [title, setTitle] = useState(null);
    const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
    const [fetchedOrganization, setFetchedOrganization] = useState(null);
    const [fetchedInventories, setFetchedInventories] = useState([]);

    const { success, error } = useSnackbar();

    const fetchOnwerDetailedPopulation = async (selOwner, startYear) => {
        console.log("Selected", selOwner, startYear)
        setIsLoading(true);
        try {
            const { lastUpdated, organization } = await getLastUpdateDate(selOwner);
            setLastUpdatedDate(lastUpdated);
            setFetchedOrganization(organization);
            const { success: scs, animals, message } = await getOwnerPopulationDetailed(selOwner, startYear);
            if (scs) {
                setFetchedData(animals);
                setSelectedYear(startYear);
                setStep(2);
            } else {
                error(message);
            }
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <SelectOwnerForm
                    setSelectedOwner={setSelectedOwner}
                    title={"Στοιχεία Πληθυσμού"}
                    method={fetchOnwerDetailedPopulation}
                    screenCase={"OwnerPopulationDetailed"}
                />
            )}
            {step === 2 && (
                <OwnerPopulationSummary
                    animals={fetchedData}
                    owner={selectedOwner}
                    setStep={setStep}
                    setSelectedData={setSelectedData}
                    setTitle={setTitle}
                    lastUpdatedDate={lastUpdatedDate}
                    setIsLoading={setIsLoading}
                    createInventory={createInventory}
                    success={success}
                    error={error}
                    getOwnerPopulationDetailed={getOwnerPopulationDetailed}
                    getInventories={getInventories}
                    setFetchedInventories={setFetchedInventories}
                />
            )}
            {step === 3 && (
                <>
                    <InfoCsvExportButton filename={`plithismos_${selectedOwner?.code || "ektrofi"}_${selectedYear}_${title}`}
                        getRows={() => detailedPopulationCsv(selectedOwner, selectedYear, title, selectedData)} disabled={!selectedData?.length} />
                    <OwnerPopulationDetailsPdf
                        data={selectedData}
                        title={title}
                        setStep={setStep}
                    />
                </>
            )}
            {step === 4 && (
                <OwnerPopulationDetailsSummaryPdf
                    data={fetchedData}
                    selectedOwner={selectedOwner}
                    lastUpdatedDate={lastUpdatedDate}
                    organization={fetchedOrganization}
                    setStep={setStep}
                />
            )}
            {step === 5 && (
                <OwnerPopulationTable
                    getInventories={getInventories}
                    owner={selectedOwner}
                    setFetchedInventories={setFetchedInventories}
                    fetchedInventories={fetchedInventories}
                    setStep={setStep}
                    deleteInventory={deleteInventory}
                />
            )}
        </>
    )
}

export default memo(OwnerPopulationDetailed)